import { getDurationBreakdown } from './datetime'

export type DisplayTimeOpts = {
  preset: 'time-with-seconds'
}

/**
 * Displays time in a some readable format
 *
 * @param millis Time in milliseconds
 * @param param1 Options @see DisplayTimeOpts
 * @returns A formatted string displaying the provided time
 */
export const displayTime = (
  millis: number,
  { preset }: DisplayTimeOpts = { preset: 'time-with-seconds' }
): string => {
  switch (preset) {
    case 'time-with-seconds': {
      const formatter = new Intl.DateTimeFormat(navigator.language, {
        dateStyle: 'short',
        timeStyle: 'medium',
      })
      return formatter
        .format(new Date(millis))
        .replaceAll('/', '-')
        .replaceAll(',', '')
    }
    default:
      throw new Error(`invalid preset: ${preset}`)
  }
}

export function formatDelay(delayMs: number) {
  const delayUnix = Math.floor(delayMs / 1000)
  if (delayUnix === 0) {
    return 'None'
  }

  const oneHour = 60 * 60
  const oneDay = oneHour * 24
  const hoursThreshold = oneHour
  const daysThreshold = oneDay

  if (delayUnix >= daysThreshold) {
    const days = Math.round(delayUnix / oneDay)
    if (days === 1) {
      return `${days} day`
    }
    return `${days} days`
  }

  if (delayUnix >= hoursThreshold) {
    const hours = Math.round(delayUnix / oneHour)
    if (hours === 1) {
      return `${hours} hour`
    }
    if (hours === 24) {
      return '1 day'
    }

    return `${hours} hours`
  }

  const seconds = delayUnix
  if (seconds === 1) {
    return `${seconds} second`
  }
  return `${seconds} seconds`
}
